import { v4 as uuid } from 'uuid';

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    author: 'Creative Seating System',
    categoryName: 'furniture',
    image:
      'https://github.com/sanket4120/Decora/blob/Dev/assets/chair.png?raw=true',
    title: 'Retrostar Velvet Chair',
    details: {
      Brand: 'Creative Seating System',
      'Dimensions(In Inches)': 'H 31.7 x W 20 x D 17',
      Weight: '3 KG',
      Warranty: '12 Months Warranty',
      Assembly: 'Carpenter Assembly',
      'Primary Material': 'Solid Wood',
      'Room Type': 'Living Room',
      'Seating Height': '18',
      'Dimensions (In Centimeters)': 'H 80.5 x W 50.8 x D 43.2',
    },
    price: '3000',
    discount: '20',
    discountPrice: '2400',
    rating: '4.5',
    stock: 0,
  },
  {
    _id: uuid(),
    author: 'Creative Seating System',
    categoryName: 'furniture',
    image:
      'https://user-images.githubusercontent.com/66076144/162123710-addba08e-bc39-4771-8177-ed3e9793233e.png',
    title: 'Akemi Iconic DSW Replica Chair',
    details: {
      Brand: 'Creative Seating System',
      'Dimensions(In Inches)': 'H 31.7 x W 20 x D 17',
      Weight: '5.5 KG',
      Warranty: '12 Months Warranty',
      Assembly: 'Carpenter Assembly',
      'Primary Material': 'Solid Wood',
      'Room Type': 'Living Room',
      'Seating Height': '18',
      'Dimensions (In Centimeters)': 'H 80.5 x W 50.8 x D 43.2',
    },
    price: '6000',
    discount: '30',
    discountPrice: '4200',
    rating: '4.5',
    stock: 3,
  },
  {
    _id: uuid(),
    author: 'Woodsworth',
    categoryName: 'furniture',
    image:
      'https://user-images.githubusercontent.com/66076144/162123921-59dda28d-0c63-4aff-8cff-3a5ed400435c.png',
    title: 'Mitsy Solid Wood Rocking Chair',
    details: {
      Brand: 'Woodsworth',
      'Dimensions(In Inches)': 'H 37 x W 22 x D 36',
      Weight: '12 KG',
      Warranty: '36 Months Warranty',
      Assembly: 'No Assembly Required',
      'Primary Material': 'Solid Wood',
      'Room Type': 'Living Room',
      'Seating Height': '17',
      'Dimensions (In Centimeters)': 'H 93.98 x W 55.88 x D 91.44',
    },
    price: '6000',
    discount: '30',
    discountPrice: '4200',
    rating: '3',
    stock: 4,
  },
  {
    _id: uuid(),
    author: 'Woodsworth',
    categoryName: 'furniture',
    title: 'Wall Desk',
    details: {
      Brand: 'Woodsworth',
      'Dimensions(In Inches)': 'H 37 x W 22 x D 36',
      Weight: '12 KG',
      Warranty: '36 Months Warranty',
      Assembly: 'No Assembly Required',
      'Primary Material': 'Solid Wood',
      'Room Type': 'Living Room',
      'Seating Height': '17',
      'Dimensions (In Centimeters)': 'H 93.98 x W 55.88 x D 91.44',
    },
    image:
      'https://github.com/sanket4120/Decora/blob/Dev/assets/furniture.png?raw=true',
    price: '3000',
    rating: '4',
    stock: 10,
  },
  {
    _id: uuid(),
    author: 'Duroflex',
    categoryName: 'furniture',
    title: 'Ease 3 Seater Sofa ',
    details: {
      Brand: 'Duroflex',
      'Dimensions(In Inches)': 'H 35 x W 73 x D 34',
      Weight: '44 KG',
      Colour: 'Beige',
      Warranty: '36 Months Warranty',
      Assembly: 'Carpenter Assembly',
      'Primary Material': 'Fabric',
      'Room Type': 'Living Room',
      'Seating Height': '18',
      'Dimensions (In Centimeters)': 'H 88.9 x W 185.4 x D 86.4',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162129340-f01560f8-56a9-45d9-9c0b-ddf3305d8b54.png',
    price: '33600',
    discount: '40',
    discountPrice: '20160',
    rating: '4.5',
    stock: 5,
  },
  {
    _id: uuid(),
    author: 'Sapphire',
    categoryName: 'lighting',
    title: 'Adalira Classic Amber Wall Light',
    details: {
      Brand: 'Sapphire',
      'Dimensions(In Inches)': '9 Inches(L) x 5Inches (B) x 10 Inches(H)',
      Weight: '800 Grams',
      Warranty: '6 Months Warranty',
      Assembly: 'Self Assembly',
      'Cord Material': 'Fabric',
      'Cord Length': '0.25 Meter',
      Colour: 'Gold and Brown',
      'Room Type': 'Living Room',
      'Seating Height': '18',
      'Dimensions (In Centimeters)': '23 cm(L) x 13cm (B) x 25 cm(H)',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150938-dd088e4f-7ff5-468c-9d5d-8e88b7bd60f3.png',
    price: '5299',
    discount: '11',
    discountPrice: '4692',
    rating: '4',
    stock: 9,
  },
  {
    _id: uuid(),
    author: 'Sapphire',
    categoryName: 'lighting',
    title: 'Beige Iron & Cloth Shade Floor Lamp',
    details: {
      Brand: 'Sapphire',
      'Dimensions(In Inches)': '9 Inches(L) x 5Inches (B) x 10 Inches(H)',
      Weight: '800 Grams',
      Warranty: '6 Months Warranty',
      Assembly: 'Self Assembly',
      'Cord Material': 'Fabric',
      'Cord Length': '0.25 Meter',
      Colour: 'Gold and Brown',
      'No. of lights': '3',
      'Dimensions (In Centimeters)': '23 cm(L) x 13cm (B) x 25 cm(H)',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150945-c15211ea-5cb2-4186-888e-c2287fe4b86d.png',
    price: '10499',
    discount: '40',
    discountPrice: '6299',
    rating: '4',
    stock: 2,
  },
  {
    _id: uuid(),
    author: 'Sapphire',
    categoryName: 'lighting',
    title: 'Transparent Glass 3 Light Cluster Hanging Lights',
    details: {
      Brand: 'Sapphire',
      'Dimensions(In Inches)': '23.6 Inches(L) x 9Inches (B) x 9 Inches(H)',
      Weight: '2.3 Kgs',
      Warranty: '6 Months Warranty',
      Assembly: 'Self Assembly',
      Material: 'Glass',
      'Cord Length': '0.25 Meter',
      Colour: 'Transparent',
      'Dimensions (In Centimeters)': '60 cm(L) x 23cm (B) x 23 cm(H)',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150949-c1b06d04-cc74-4002-8748-ad9f03d4a74d.png',
    price: '5499',
    discount: '33',
    discountPrice: '3704',
    rating: '3',
    stock: 4,
  },
  {
    _id: uuid(),
    author: 'Sapphire',
    categoryName: 'lighting',
    title: 'White Fabric Shade Table Lamp',
    details: {
      Brand: 'Sapphire',
      'Dimensions(In Inches)': '6 Inches(L) x 8Inches (B) x 16.5 Inches(H)',
      Weight: '550 Grams',
      Warranty: '6 Months Warranty',
      Assembly: 'Self Assembly',
      Material: 'Fabric',
      'Cord Length': '0.25 Meter',
      Colour: 'White',
      'Dimensions (In Centimeters)': '15 cm(L) x 20cm (B) x 42 cm(H)',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150951-739802d3-97e0-4dad-9e84-6e3a29f43b7e.png',
    price: '2799',
    discount: '49',
    discountPrice: '1427',
    rating: '5',
    stock: 10,
  },
  {
    _id: uuid(),
    author: 'Sapphire',
    categoryName: 'lighting',
    rating: '4',
    stock: 10,
    title: 'White Fabric Shade Table Lamp with Black Base',
    details: {
      Brand: 'Sapphire',
      'Dimensions(In Inches)': '8 Inches(L) x 8Inches (B) x 13 Inches(H)',
      Weight: '700 Grams',
      Warranty: '6 Months Warranty',
      Assembly: 'Self Assembly',
      Material: 'Fabric',
      Colour: 'White',
      'Wire Length': '1.5 Meter',
      'Dimensions (In Centimeters)': '20 cm(L) x 20cm (B) x 33 cm(H)',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150954-2fa684d5-7e22-4a06-bac3-42307dd2dce3.png',
    price: '2439',
  },
  {
    _id: uuid(),
    author: 'Fourwalls',
    categoryName: 'decor',
    rating: '3.5',
    stock: 10,
    title: 'Brown Metal Hanging Basket',
    details: {
      Brand: 'Fourwalls',
      'Dimensions(In Inches)': 'Length:12, Width:12, Height:22 Inches',
      Weight: '0.5 Kg',
      Assembly: 'No Assembly Required',
      Material: 'Metal',
      Colour: 'Brown',
      'Dimensions (In Centimeters)': 'Length:30.5, Width:30.5, Height:55.9',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162151210-a4e4d1d4-ae68-4698-874a-bd380e98f93f.png',
    price: '609',
    discount: '36',
    discountPrice: '391',
  },
  {
    _id: uuid(),
    author: 'Fourwalls',
    categoryName: 'decor',
    rating: '4',
    stock: 10,
    title: 'Golden Deidra Metal Table Vase',
    details: {
      Brand: 'Fourwalls',
      'Dimensions(In Inches)':
        'Large- L 5.5 x B 5.5 x H 12; Small- L 5x B 5 x H 10',
      Weight: '1.9 Kgs',
      Assembly: 'No Assembly Required',
      Material: 'Metal',
      Colour: 'Gold',
      'Dimensions (In Centimeters)': 'L 14 x B 14 x H 30.5',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162151218-74fc04ae-7b0e-47d1-8432-b96f77629dbc.png',
    price: '7599',
    discount: '42',
    discountPrice: '4483',
  },
  {
    _id: uuid(),
    author: 'Fourwalls',
    categoryName: 'decor',
    rating: '4',
    stock: 10,
    title: 'Royal Elephant Deocrative Wall Plate',
    details: {
      Brand: 'Fourwalls',
      'Dimensions(In Inches)': 'Height: 8, Width: 8,Depth: 0.5 ( In Inches)',
      Weight: '1.9 Kgs',
      Assembly: 'No Assembly Required',
      Material: 'Ceramic',
      Colour: 'Multicolour',
      'Dimensions (In Centimeters)': '20.32 X 20.32 in cm',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162151219-7662c2d3-8473-4aa9-b19e-cc947c1b350b.png',
    price: '1299',
    discount: '42',
    discountPrice: '799',
  },
  {
    _id: uuid(),
    author: 'Fourwalls',
    categoryName: 'decor',
    rating: '5',
    stock: 3,
    title: 'Urn Terracotta Vase',
    details: {
      Brand: 'Fourwalls',
      'Dimensions(In Inches)': 'Pot 1- H 6 x DIA 5.5; Pot 2- H 6 x DIA 3.3',
      Weight: '1.9 Kgs',
      Assembly: 'No Assembly Required',
      Material: 'Terracotta',
      Colour: 'White',
      'Dimensions (In Centimeters)':
        'Pot 1- Dia 14 x H 15.2; Pot 2- Dia 8.4 x H 15.2',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162151226-4fa481ef-c7b0-4e0a-a2fc-c2f2c4e90703.png',
    price: '1999',
    discount: '34',
    discountPrice: '1329',
  },
  {
    _id: uuid(),
    author: 'Fourwalls',
    categoryName: 'decor',
    rating: '4',
    stock: 10,
    title: 'Art Deocrative Wall Plate',
    details: {
      Brand: 'Fourwalls',
      'Dimensions(In Inches)': 'Height: 8, Width: 8,Depth: 0.5 ( In Inches)',
      Weight: '1.9 Kgs',
      Assembly: 'No Assembly Required',
      Material: 'Ceramic',
      Colour: 'Multicolour',
      'Dimensions (In Centimeters)': '20.32 X 20.32 in cm',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162151227-048c0c1b-f780-4f39-84b5-65a0048dab94.png',
    price: '1299',
    discount: '42',
    discountPrice: '799',
  },
  {
    _id: uuid(),
    author: 'Go Hooked',
    categoryName: 'paintings',
    rating: '4',
    stock: 4,
    title: 'MDF Digital Print Set of 3 Wall Art Painting',
    details: {
      Brand: 'Go Hooked',
      'Dimensions(In Inches)': 'Height: 17.5 x Width: 18 x Length: 0.2 Inches',
      Weight: '0.6 Kg',
      Assembly: 'Self Assembly',
      Material: 'MDF',
      'Frame Type': 'Framed',
      Orientation: 'Landscape',
      Colour: 'Cream',
      'Frame Colour': 'Black',
      'Dimensions (In Centimeters)': '45.72 X 45.72 in cm',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150055-81fdc441-e016-4d3f-a723-8e7ec0944285.png',
    price: '1499',
    discount: '51',
    discountPrice: '735',
  },
  {
    _id: uuid(),
    author: 'Go Hooked',
    categoryName: 'paintings',
    rating: '4.5',
    stock: 10,
    title: 'Yellow Figurine Set',
    details: {
      Brand: 'Go Hooked',
      'Dimensions(In Inches)':
        'Length: 22.5 x Width: 0.5 x Height: 13.5 Inches',
      Weight: '0.5 Kg',
      Assembly: 'Self Assembly',
      Material: 'Plastic',
      'Frame Type': 'Framed',
      Orientation: 'Portrait',
      Colour: 'Yellow',
      'Frame Colour': 'Black',
      'Dimensions (In Centimeters)': '57.15 X 1.27 X 34.29 In cm',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150799-85ec5ff2-dcf9-4935-ac06-5e6a274888d3.png',
    price: '1124',
    discount: '71',
    discountPrice: '322',
  },
  {
    _id: uuid(),
    author: 'Go Hooked',
    categoryName: 'paintings',
    rating: '3',
    stock: 10,
    title: 'Framed Canvas Abstract Painting',
    details: {
      Brand: 'Go Hooked',
      'Dimensions(In Inches)': '40x30 Inches',
      Weight: '3.1',
      Assembly: 'No Assembly Required',
      Material: 'Canvas',
      'Frame Type': 'Framed',
      Orientation: 'Portrait',
      Colour: 'Multicolour',
      'Frame Colour': 'Black',
      'Dimensions (In Centimeters)': '101.60 X 76.20 In Cm',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150811-7c2bb3d9-7ea1-4a7f-8383-e7c8dddd99c8.png',
    price: ' 5999',
    discount: '45',
    discountPrice: '3324',
  },
  {
    _id: uuid(),
    author: 'Go Hooked',
    categoryName: 'paintings',
    rating: '3.5',
    stock: 3,
    title: 'White Niagarra Falls Canvas',
    details: {
      Brand: 'Go Hooked',
      'Dimensions(In Inches)': '20 inches (L) x 0.8 inches(B) x 20 inches(H)',
      Weight: '750 grams',
      Assembly: 'No Assembly Required',
      Material: 'Canvas',
      'Frame Type': 'Framed',
      Orientation: 'Landscape',
      Colour: 'White',
      'Dimensions (In Centimeters)': '50.80 X 2.03 X 50.80 In Cm',
    },
    image:
      'https://user-images.githubusercontent.com/66076144/162150813-9cdafa46-9fa6-410a-8d0b-223a39f365d8.png',
    price: '7500',
    discount: '32',
    discountPrice: '5099',
  },
];
